export default "__VITE_ASSET__hwwDhbsR__"